module.exports = function _isObject(x) {
  return Object.prototype.toString.call(x) === '[object Object]';
};



//////////////////
// WEBPACK FOOTER
// /home/deploy/7n_production/shared/~/ramda/src/internal/_isObject.js
// module id = 63
// module chunks = 0 2 3 4 5 6 7